import { useDispatch } from "react-redux/es/exports";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { useState } from "react";
import { login } from "../../feature/login/loginSlice";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [user, setUser] = useState({
    email: "example@admin.com",
    password: "123456",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login(user));
    navigate("/");
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setUser((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  return (
    <Container component='main' maxWidth='xs'>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          // bgcolor: "#fff",
          flexDirection: "column",
          alignItems: "center",
          // minWidth: "500px",
        }}
      >
        <Typography variant='h5'>Login</Typography>
        <Typography variant='h6'>Hello! Log in with your email.</Typography>
        <Box component='form' onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin='normal'
            required
            fullWidth
            id='email'
            type='email'
            label='Email Address'
            name='email'
            autoComplete='email'
            autoFocus
            value={user.email}
            onChange={handleChange}
          />
          <TextField
            margin='normal'
            required
            fullWidth
            name='password'
            label='Password'
            type='password'
            id='password'
            autoComplete='current-password'
            value={user.password}
            onChange={handleChange}
          />
          <FormControlLabel
            control={<Checkbox value='remember' />}
            label='Remember me'
          />
          <Button
            type='submit'
            fullWidth
            variant='contained'
            sx={{
              mt: 3,
              mb: 2,
              color: "#ffffff",
              bgcolor: "#3366ff",
              "&:hover": { bgcolor: "#598bff" },
            }}
          >
            Sign In
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
